import Icon from '@ant-design/icons';

const RedirectSvg = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon/16/Redirect">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.75 14.25H2.25C1.97344 14.25 1.75 14.0266 1.75 13.75V2.25C1.75 1.97344 1.97344 1.75 2.25 1.75H7.875C7.94375 1.75 8 1.80625 8 1.875V2.75C8 2.81875 7.94375 2.875 7.875 2.875H2.875V13.125H13.125V8.125C13.125 8.05625 13.1812 8 13.25 8H14.125C14.1938 8 14.25 8.05625 14.25 8.125V13.75C14.25 14.0266 14.0266 14.25 13.75 14.25ZM12.0448 3.11142L11.2292 2.2958C11.1558 2.22236 11.1995 2.0958 11.3027 2.0833L14.1058 1.75517C14.1855 1.7458 14.2542 1.81298 14.2448 1.89423L13.9167 4.69736C13.9042 4.80048 13.7777 4.84423 13.7042 4.7708L12.8855 3.95205L8.88234 7.95517C8.83391 8.00361 8.75422 8.00361 8.70578 7.95517L8.04328 7.29267C7.99484 7.24423 7.99484 7.16455 8.04328 7.11611L12.0448 3.11142Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const RedirectIcon = (props: any) => <Icon component={RedirectSvg} {...props} />;
